import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig } from "../../../../store/slices/BillToMapping/billToMappingSlice";
import { createBillToMapping, editBillToMapping } from "../api";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useGetBillToMappingBasicDataQuery } from "../../../../store/queries/Master";

const useAddBillToMapping = ({ refetch }) => {
  const dispatch = useDispatch();
  const billToMappingState = useSelector((state) => state.billToMapping);

  const { data: basicData = {} } = useGetBillToMappingBasicDataQuery({});

  useEffect(() => {
    if (billToMappingState?.billToMappingData && billToMappingState?.isEdit) {
      const data = billToMappingState?.billToMappingData;
      formik?.setFieldValue("supplier_id", data?.supplier_id || "");
      formik?.setFieldValue("shop_id", data?.shop_id || "");
      formik?.setFieldValue("bill_to_id", data?.bill_to_id || "");
      formik?.setFieldValue("remark", data?.remark || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billToMappingState?.billToMappingData]);

  const validation = Yup.object({
    supplier_id: Yup.string().required("Select Supplier"),
    shop_id: Yup.string().required("Select Shop"),
    bill_to_id: Yup.string().required("Select Bill To"),
    remark: Yup.string().trim(),
  });

  const formik = useFormik({
    initialValues: {
      supplier_id: "",
      shop_id: "",
      bill_to_id: "",
      remark: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      let data = {
        supplier_id: values?.supplier_id,
        shop_id: values?.shop_id,
        bill_to_id: values?.bill_to_id,
        remark: values?.remark,
      };

      const apiCall = billToMappingState?.isEdit
        ? editBillToMapping({
            ...data,
            bill_to_mapping_id: billToMappingState?.selectedBillToMapping,
          })
        : createBillToMapping(data);

      apiCall.then((response) => {
        if (response?.data?.status_code === 200) {
          handleCloseModal();
          toast.success(
            billToMappingState?.isEdit
              ? "Bill To  Updated"
              : "Bill To added successfully"
          );
          dispatch(
            updateConfig((state) => {
              state.clearSelection = true;
            })
          );
          refetch();
        } else if (response?.status_code === 422) {
          let errors = response?.errors;
          let errorFields = Object.keys(errors);
          errorFields.forEach((field) => {
            formik.setFieldError(field, errors[field]);
          });
        } else {
          toast.error("Something went wrong");
        }
      });
    },
  });

  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showAddBillToMappingModal = false;
      })
    );
  };

  return {
    formik,
    billToMappingState,
    getFieldError,
    handleCloseModal,
    basicData,
  };
};

export default useAddBillToMapping;
